import { atom } from 'recoil'

export const errorForgotPasswordState = atom({
  key: 'errorForgotPasswordState',
  default: null,
})
